/* eslint-disable react/prop-types */
import { Flex, Text } from "@chakra-ui/react";
import Clock from "../Clock";
import { motion } from "framer-motion";
import React from "react";

const motionProps = {
  initial: { y: "-100%", opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { opacity: 0 },
  transition: {
    type: "tween",
    duration: 2,
  },
};

const Header = ({ customerName, tenantName }) => {
  const reload = () => {
    window.location.href = window.location.origin;
  };
  return (
    <Flex
      layerStyle={"kioskHeader"}
      bg={"rgba(0,0,0,.5)"}
      as={motion.header}
      {...motionProps}
    >
      <Text fontSize="xl" onClick={reload} data-testid={"customer-tenant-name"}>
        {customerName} {tenantName}
      </Text>
      <Text fontSize="xl" color="brand.text.DEFAULT" data-testid={"clock"}>
        <Clock />
      </Text>
    </Flex>
  );
};

export default Header;
